var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_398_800",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_398_800",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAETklEQVR4nO2dT2gcVRjAf282rCGI0oJtY+1BaDYpapW2otQelIKoKAWxnvQgCu4WhB5ExJaSHhRF6kHR3ab4By9Cg1pPNlL0pCiYg9TIZmtLwLaI1eQg1ibpzudFkKrNpPvezH4z+/2u+833fcxv5+17b5YZMAzDMIzOcOmXGI0YOns7UfQQwhC460H6gXM4N4XER2kNfgGjcfq96Cc9IXeP9nHm5ydx7AHWJUT/AOyl1fg4tX5yQjpCNlRvps1hYMOVdSPv0jdbZWp8IZW+ckB4IZWnHwD3AXBNhxk+ZeHCw8y8dyFkW3khCpptZNdWcB/RuQyA+yn3j4VqKW+UgmWqVNci8jlwbYBst7Jyc4vZye8D5MoVAa8Q9xKwOlw6d4D1z/hcabkkjJDh2kaQx4Lk+odBShdrgXOqpy9Iljh+AueWI7eJ4zOQecTdBmxnqS+FyG6Gc+RE2p/QGmv6pAgjxEU7QJaOEfccJ1YfuGQBOLJrK3F8BLjuMketQeTlID1mgSudAryE+A9Z65+6AeTGhKhDnKi/+p/VePOtr4h43LuHAuEvxEVrE2NKvH7Zz5qNCWDau4+C4C8kcmsSYwbipBPudZkXiQCzrKicGDI5tpgQ0bNbJf8m7Erd8MaEKCPMtDd95oBT3W4C2Jx2gbwIOUar8Wi3m6BSTVhs+WNDljJMiDJMiDJMiDJMiDJMiDJMiDLysg5JplL91i+BHKN18PkwzXROcYR4r6Kdhp0AG7K0YUKUYUKUYUKUYUKUYUKUUaBpr7zidbhzxwM14kVxhChY1IXAhixlmBBlmBBlmBBlmBBlmBBlFGfaO1Lz236PmaNV7/oWfHGExOJ5g4pxoOt/xrMhSxkmRBkmRBkmRBkmRBkmRBkmRBnFWYdEbovX8TFzgTrxojhCmvXJbrcQAhuylGFClGFClGFClGFClGFClGFClGFClGFClGFClJHd1slNO8vMrxoiigdxrLjkM5Gkh/WvY7i2M73mlomk/uyZjIRUqkdYZDtR+2og8QGm/8OdiBwO3ZZGsrpCdmRUJ/fYb4gyTIgyTIgyTIgyTIgyTIgysrynPoO4PZQXjjL19myGdXNFVkJmaHMHJ+u/ZFQvt2QjROQFTh40Gcsgm9+Q8sWJTOoUAH8hsfyZGPNH+7x3nR7BX4jEZxNj+gc2edfpEQIIiU4nxsTxXjJ5EXL+CXOSKtXvgI0Jpd7nKnZzvK7iP7RaCSSkth9k3zKqnUfkG3C/Bqmrjdi9xo/1r31SBJr2yhiOZxEGlg5jANw9YWoqpMQ44CUkzLS31TiDyBtBcvU44dYhbvFFkKlg+XqUcEKm3/mdyD0InAuWswcJu1JvNmaI2tuwF0V2TPitk+ahFlHpLhwfBs/dA6Szl9V88zemG4/g2IYwASS9WNL4m3R3e6cbXwL3cUttBfPxveBGcAwirEy1brdo81O3WzAMwzAMwzAMw7hS/gKbuuaAfp1qVQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublication);
export default __webpack_public_path__ + "static/media/publication.477f9240bab8e67b7aa21a05f0dca3ff.svg";
export { ForwardRef as ReactComponent };